var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTasksPaths(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.6 57.6) scale(0.775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.14 101.71L67.43 136L136 33.14",
    stroke: "white",
    strokeWidth: 34.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.57 67.43H478.86C488.33 67.43 496 75.10 496 84.57C496 94.04 488.33 101.71 478.86 101.71H204.57C195.10 101.71 187.43 94.04 187.43 84.57C187.43 75.10 195.10 67.43 204.57 67.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.29 187.43H118.86C137.79 187.43 153.14 202.78 153.14 221.71V290.29C153.14 309.22 137.79 324.57 118.86 324.57H50.29C31.36 324.57 16 309.22 16 290.29V221.71C16 202.78 31.36 187.43 50.29 187.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.57 238.86H478.86C488.33 238.86 496 246.53 496 256C496 265.47 488.33 273.14 478.86 273.14H204.57C195.10 273.14 187.43 265.47 187.43 256C187.43 246.53 195.10 238.86 204.57 238.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.29 358.86H118.86C137.79 358.86 153.14 374.21 153.14 393.14V461.71C153.14 480.64 137.79 496 118.86 496H50.29C31.36 496 16 480.64 16 461.71V393.14C16 374.21 31.36 358.86 50.29 358.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.57 410.29H478.86C488.33 410.29 496 417.96 496 427.43C496 436.90 488.33 444.57 478.86 444.57H204.57C195.10 444.57 187.43 436.90 187.43 427.43C187.43 417.96 195.10 410.29 204.57 410.29Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTasksPaths);
export default __webpack_public_path__ + "static/media/New-Tasks-paths.63b23ff469bd3f757ec946d38ee4644f.svg";
export { ForwardRef as ReactComponent };